<template>
  <div>
    <Modal
      v-model="show"
      :title="(type == 1 ? $t('Info.copyright'):type == 3 ? $t('Info.homepage'):$t('Info.condition'))+$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel()"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="140" label-colon>
          <FormItem v-if="type == 2" prop="en_base_tnc" :label="$t('content') + '(en)'">
            <Input
              v-model="form.en_base_tnc"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              :placeholder="type == 1 ? 'Please enter the copyright content': 'Please enter the treaty content'"
            />
          </FormItem>
          <FormItem v-if="type == 2" prop="zh-tw_base_tnc" :label="$t('content') + '(繁体)'">
            <Input
              v-model="form['zh-tw_base_tnc']"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              :placeholder="type == 1 ? '請輸入版權內容': '請輸入條約內容'"
            />
          </FormItem>
          <FormItem v-if="type == 2 " prop="zh-cn_base_tnc" :label="$t('content') + '(简体)'">
            <Input
              v-model="form['zh-cn_base_tnc']"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder=" '请输入条约内容'"
            />
          </FormItem>
          <FormItem v-if="type == 1 " prop="copyright" :label="$t('content')">
            <Input
              v-model="form.copyright"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              :placeholder="$t('Info.copyrightInput')"
            />
          </FormItem>
          <FormItem v-if="type == 3 " prop="homepage" :label="$t('content')">
            <Input v-model="form.homepage" type="input" :placeholder="$t('Info.homepageInput')" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" :loading="loading" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    conditionObj: String,
    type: Number,
  },
  data () {
    return {
      form: {
        copyright: "",
        homepage: "",
        en_base_tnc: "",
        "zh-cn_base_tnc": "",
        "zh-tw_base_tnc": "",
      },
      ruleInline: {
        en_base_tnc: [
          {
            required: true,
            message: this.type == 1 ? this.$t('Info.copyrightInput') : this.$t('Info.contentInput') + "(en)",
            trigger: "blur"
          }
        ],
        "zh-tw_base_tnc": [
          {
            required: true,
            message: this.$t('Info.contentInput') + "(繁体)",
            trigger: "blur"
          }
        ],
        "zh-cn_base_tnc": [
          {
            required: true,
            message: this.$t('Info.contentInput') + "(简体)",
            trigger: "blur"
          }
        ],
        copyright: [
          {
            required: true,
            message: this.$t('Info.copyrightInput'),
            trigger: "blur"
          }
        ],
        homepage: [
          {
            required: true,
            message: this.$t('Info.homepageInput'),
            trigger: "blur"
          }
        ]
      },
      loading: false,
      show: this.modal
    }

  },
  created () {

  },
  mounted () {
    this.form = JSON.parse(this.conditionObj)
  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    submit (name) {
      this.loading = true
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$emit('ok', this.form);
          this.cancel()
        } else {
          this.error()
        }
        this.loading = false
      });

    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80%;
  margin: 20px 0 20px 10%;

  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/info/module/condition_edit.vue